// extracted by mini-css-extract-plugin
export var linkText = "_pp-0";